/* BYKSKI.US — bk-cart-variant.js (2.26.3)
   Change a cart line's variant (a fitting's color) without leaving the cart. Used by the cart
   drawer and the cart page, so both swap a line the same way.

   Shopify has no "change variant" call: a line is one variant. So the new variant is ADDED first,
   with the same quantity and the same line properties (Fulfillment, Dispatch window), and only
   then is the old line removed. Add-then-remove, never the reverse: if the add fails (out of
   stock, a network drop) the customer still has the part they had, instead of an empty line.

   window.BKCartVariant.swap(key, newVariantId, quantity, properties) -> Promise<cart>
   window.BKCartVariant.fill(scope) fills every select.bk-cv[data-handle] in scope with that
   product's variants (one /products/<handle>.js fetch per product, cached for the page). */
(function(){
  if (window.BKCartVariant) return;
  var cache = {};
  function product(handle){
    if (!cache[handle]) {
      cache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { 'Accept': 'application/json' } })
        .then(function(r){ if (!r.ok) throw new Error('product'); return r.json(); })
        .catch(function(e){ delete cache[handle]; throw e; });
    }
    return cache[handle];
  }
  function swap(key, vid, qty, props){
    var add = { items: [{ id: parseInt(vid, 10), quantity: qty || 1 }] };
    if (props && typeof props === 'object' && Object.keys(props).length) add.items[0].properties = props;
    return fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify(add) })
      .then(function(r){ if (!r.ok) throw new Error('add'); return r.json(); })
      .then(function(){
        return fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ id: key, quantity: 0 }) });
      })
      .then(function(r){ if (!r.ok) throw new Error('remove'); return r.json(); });
  }
  function fill(scope){
    (scope || document).querySelectorAll('select.bk-cv[data-handle]:not([data-filled])').forEach(function(sel){
      sel.setAttribute('data-filled', '');
      var cur = String(sel.getAttribute('data-vid'));
      product(sel.getAttribute('data-handle')).then(function(p){
        if (!p.variants || p.variants.length < 2) { sel.hidden = true; return; }
        sel.innerHTML = '';
        p.variants.forEach(function(v){
          var o = document.createElement('option');
          o.value = v.id;
          o.textContent = v.title + (v.available ? '' : ' - out of stock');
          if (!v.available && String(v.id) !== cur) o.disabled = true;
          if (String(v.id) === cur) o.selected = true;
          sel.appendChild(o);
        });
        sel.disabled = false;
      }).catch(function(){ /* keep the one-option select showing the current variant */ });
    });
  }
  /* 2.26.6 — the picker is folded behind a link showing the variant itself ("Silver", "4 Channels") on each line, so a cart of six
     color-variant fittings is not six selects tall. The click unfolds THAT line's select, fills it
     (drawer lines are filled only now, one product fetch on demand) and hides the link. */
  document.addEventListener('click', function(e){
    var b = e.target.closest && e.target.closest('[data-bk-cvopen]'); if (!b) return;
    e.preventDefault();
    var line = b.closest('li') || b.parentElement.parentElement;
    var sel = line && line.querySelector('select.bk-cv, select.bk-cv-page'); if (!sel) return;
    sel.hidden = false; b.hidden = true;
    if (sel.matches('select.bk-cv')) fill(line);
    try { sel.focus(); } catch (err) {}
  });
  window.BKCartVariant = { swap: swap, fill: fill };
})();
